/**
 * Admin panel route metadata — always treated as private (noindex).
 */

import type { PageMetaEntry } from './types';

export const ADMIN_PAGE_META: readonly PageMetaEntry[] = [
  {
    path: '/admin/login',
    title: 'Admin Sign In',
    description: 'Sign in to the BuzzBit X admin panel.',
    indexable: false,
  },
  {
    path: '/admin/tenants',
    title: 'Admin · Tenants',
    description: 'Administer BuzzBit X tenant workspaces.',
  },
  {
    path: '/admin/users',
    title: 'Admin · Users',
    description: 'Administer BuzzBit X users.',
  },
  {
    path: '/admin/billing',
    title: 'Admin · Billing',
    description: 'Administer BuzzBit X billing.',
  },
  {
    path: '/admin/revenue',
    title: 'Admin · Revenue',
    description: 'Admin revenue overview for BuzzBit X.',
  },
  {
    path: '/admin/support',
    title: 'Admin · Support',
    description: 'Admin support tools for BuzzBit X.',
  },
  {
    path: '/admin/logs',
    title: 'Admin · Logs',
    description: 'System logs for BuzzBit X administration.',
  },
  {
    path: '/admin/health',
    title: 'Admin · Health',
    description: 'Platform health checks for BuzzBit X.',
  },
  {
    path: '/admin/monitoring',
    title: 'Admin · Monitoring',
    description: 'Operational monitoring for BuzzBit X.',
  },
  {
    path: '/admin/credits',
    title: 'Admin · Credits',
    description: 'Manage AI credits across BuzzBit X tenants.',
  },
  {
    path: '/admin/calendar',
    title: 'Admin · Calendar',
    description: 'Admin calendar tools for BuzzBit X.',
  },
  {
    path: '/admin/marketing',
    title: 'Admin · Marketing',
    description: 'Admin marketing controls for BuzzBit X.',
  },
  {
    path: '/admin/email-marketing',
    title: 'Admin · Email Marketing',
    description: 'Admin email marketing controls for BuzzBit X.',
  },
  {
    path: '/admin/popups',
    title: 'Admin · Popups',
    description: 'Admin popup controls for BuzzBit X.',
  },
  {
    path: '/admin/social-automator',
    title: 'Admin · Social Automator',
    description: 'Admin social automator controls for BuzzBit X.',
  },
  {
    path: '/admin/business-hub',
    title: 'Admin · Business Hub',
    description: 'Admin business hub controls for BuzzBit X.',
  },
  {
    path: '/admin/brand-dna',
    title: 'Admin · Brand DNA',
    description: 'Admin brand DNA controls for BuzzBit X.',
  },
  {
    path: '/admin/integrations',
    title: 'Admin · Integrations',
    description: 'Admin integration controls for BuzzBit X.',
  },
  {
    path: '/admin/team',
    title: 'Admin · Team',
    description: 'Admin team management for BuzzBit X.',
  },
  {
    path: '/admin/api-keys',
    title: 'Admin · API Keys',
    description: 'Admin API key management for BuzzBit X.',
  },
  {
    path: '/admin',
    title: 'Admin',
    description: 'BuzzBit X platform administration.',
  },
];
